import { render, staticRenderFns } from "./EvaluateBox.vue?vue&type=template&id=797ed706&scoped=true&"
import script from "./EvaluateBox.vue?vue&type=script&lang=js&"
export * from "./EvaluateBox.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateBox.vue?vue&type=style&index=0&id=797ed706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ed706",
  null
  
)

export default component.exports